import React from "react";

import { 
  HeaderContainer, 
  NavbarContainer, 
  Wrapper, 
  NavbarLink, 
  StyledLink } from "../styled-components/headerstyle"

const Header = ({ aboutRef, artprojectListRef }) => {
  const onAboutClick = (e) => {
    e.preventDefault();
    aboutRef.current?.scrollIntoView({behavior: 'smooth'});
  };

  const onArtprojectClick = (e) => {
    e.preventDefault();
    artprojectListRef.current?.scrollIntoView({behavior: 'smooth'});
  };

  return (
    <HeaderContainer>
      <NavbarContainer>
        <Wrapper>
        <NavbarLink onClick={onArtprojectClick}>
          Art projects /
        </NavbarLink>
        <NavbarLink>
        <StyledLink to="/techprojects">
          Tech projects
        </StyledLink>
        </NavbarLink>
        </Wrapper>
        <NavbarLink onClick={onAboutClick}>
          About
        </NavbarLink>
      </NavbarContainer>
    </HeaderContainer>
  )
}

export default Header;